// src/pages/Onboard/StepWorkStatus.jsx
import React, { useState } from "react";
import axios from "axios";
import api from "../../utils/api";


function Progress({ step, total }) {
  const pct = Math.round((step / total) * 100);
  return (
    <div style={{ marginBottom: 12 }}>
      <div style={{ height: 6, background: "#EDF2F7", borderRadius: 999 }}>
        <div
          style={{
            width: `${pct}%`,
            height: 6,
            background: "#10B981",
            borderRadius: 999,
            transition: "width .3s ease"
          }}
        />
      </div>
      <small className="muted">Step {step} of {total}</small>
    </div>
  );
}

export default function StepWorkStatus({ totalSteps = 5, onPass }) {
  const [work, setWork] = useState("citizen");
  const [kitchen, setKitchen] = useState(true);
  const [age, setAge] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const next = async () => {
    setMsg("");
    const numericAge = Number(age);
    if (!Number.isFinite(numericAge) || numericAge < 18) {
      setMsg("You must be 18+ to sell food.");
      return;
    }
    setLoading(true);
    try {
      const r = await api.post(`/public/eligibility/checks`, {
        work_right: work, has_kitchen: kitchen, age: numericAge
      });
      if (r.data.pass) onPass && onPass();
      else setMsg("It looks like one or more requirements aren’t met.");
    } catch {
      setMsg("Couldn’t check. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (

<div className="onboard-wrapper">
    <div className="onboard-card">

    <section className="card" style={{ maxWidth: 680, margin: "2rem auto" }}>
      <Progress step={3} total={totalSteps} />
      <h3>Quick eligibility</h3>
      <div className="add-form">
        <label>
          <select value={work} onChange={e => setWork(e.target.value)}>
            <option value="citizen">Eligible to work: Citizen</option>
            <option value="ilr">Eligible to work: ILR/Settled</option>
            <option value="visa">Eligible to work: Visa with right to work</option>
          </select>
        </label>

        <label className="checkbox">
          <input type="checkbox" checked={kitchen} onChange={e => setKitchen(e.target.checked)} />
          <span>I have access to a kitchen with sole control when I’m cooking</span>
        </label>

        <label>
          <input
            type="number"
            min={18}
            max={100}
            value={age}
            onChange={e => setAge(e.target.value)}
            placeholder="Your age"
            inputMode="numeric"
          />
          <small className="hint">You must be 18+ to sell food</small>
        </label>

        <div className="actions">
          <button className="btn" onClick={next} disabled={loading}>
            {loading ? "Checking..." : "Continue"}
          </button>
        </div>
        {msg && <div className="toast error">{msg}</div>}
      </div>
    </section>

 </div>
  </div>


  );
}

